import React, { useState, useEffect, useRef } from "react";
import { imsLoader, iconiMSAuthoring, GenAiPDFIcon, GenAiDOCIcon, GenAiPPTIcon } from '../../assets';
//import "./GenAIAuthoring2Index.css";

import Dropzone from 'react-dropzone';
import ApiServices from "../../utils/apiServices";
import { v4 as uuidv4 } from 'uuid';
import { LocationOrigin, multiFilesAccept } from '../../utils/utilityServices';
import { Authentication } from "../../utils/authenticationUtilityServices";
import axios from "axios";
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import threadingService from "../../services/threadingService";
import { Modal } from "react-bootstrap";
import CreateUserPromptTemplate from "../PopUp/CreateUserPromptTemplate";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AuthoringProjectService from "../../services/AuthoringProjectService"
import { UserData } from "../../auth/Authorization";
import CreateUserPromptTemplateNoteBook from "../PopUp/CreateUserPromptTemplateNoteBook";


let _locationOrigin = LocationOrigin;
let _timeoutTime = (1000 * (300));
let ts = new threadingService();
let aps = new AuthoringProjectService();


function NoteBookPosterPrompt(props) {
    const services = new ApiServices();
    let guid = uuidv4();
    let threadGuid = uuidv4();
    const [sessionID, setSessionId] = useState(guid)
    const [threadID, setthreadID] = useState(threadGuid)
    const [newThreadID, setnewThreadID] = useState(threadGuid)
    const [updateAnyFile, setupdateAnyFile] = useState(false)
    const [startProject, setstartProject] = useState(true);
    const [uploadFilePlaceHolder, setuploadFilePlaceHolder] = useState("");
    const [uploadFilePlaceHolderTitle, setuploadFilePlaceHolderTitle] = useState("");
    const [isAttachedFile, setisAttachedFile] = useState(false)
    const [selectProjectType, setselectProjectType] = useState(false)
    const [selectedProjectType, setselectedProjectType] = useState('');
    const [selectOption, setselectOption] = useState([])
    const [projectName, setprojectName] = useState('')
    const [isProjectName, setisProjectName] = useState(false)
    const [spinnerMessage, setspinnerMessage] = useState('')
    const [isProcessing, setisProcessing] = useState(false)
    const [documentSelected, setdocumentSelected] = useState(true)
    const [newAttachedFiles, setnewAttachedFiles] = useState([])
    const [alertMessageContent, setalertMessageContent] = useState("")
    const [alertMessageModelColor, setalertMessageModelColor] = useState("")
    const [alertMessageShowModal, setalertMessageShowModal] = useState(false)
    const [removedAttachedFileIndex, setremovedAttachedFileIndex] = useState(-1)
    const [manageAttachedIndex, setmanageAttachedIndex] = useState(false)
    const [attachedFiles, setattachedFiles] = useState([])
    const [prompt, setPrompt] = useState([])
    const [loader, setLoader] = useState(false)
    const [readingLevel, setReadingLevel] = useState(["8", "9", "10", "12"])
    const [selectedReadingLevel, setSelectedReadingLevel] = useState("8")
    const [attachedFilePopupCollapsed, setattachedFilePopupCollapsed] = useState(false)
    const [valid, setValid] = useState(false)
    const [getProjectName, setgetProjectName] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const inputRef = useRef(null);

    const history = useHistory();

    useEffect(()=>{
        if(props.selectedProjectType.project_type_name === 'Plain Language Summary Poster'){
            getAllPrompts(props.selectedProjectType)
            setselectProjectType(true)
        }

    },[props.selectedProjectType])

    
    const handleValidation = (field, value) => {
        let errors = {};
        let isValid = true;
        if (field.startsWith('wordLimit')) {
            let filterError = prompt.filter(val => val.prompt).map((val, index) => {
                if (!val.word_limit || Number.isNaN(parseInt(val.word_limit))) {
                    isValid = false;
                    errors[`wordLimit${index}`] = '*Please enter a numeric value.'
                    return (index)
                }
                else if (val.word_limit < 50) {
                    isValid = false;
                    errors[`wordLimit${index}`] = '*Please enter word limit greater than 50.'
                    return (index)
                }
            }).filter(val => val)
            if (filterError.length > 0) {
                isValid = false
            }
            setErrorMsg(errors)
            return isValid
        } else {
            if (value.length > 1) {
                errors[`${field}`] = '*Please enter character less than 100';
                isValid = false;
            }
        }
        setErrorMsg(errors)
        return (isValid)

    }

    const successAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#00c12c")
        setalertMessageShowModal(true)
    }

    const closeAlertMessage = () => {
        setalertMessageContent("");
        setalertMessageModelColor("");
        setalertMessageShowModal(false);

    }
    const errorAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#de1327")
        setalertMessageShowModal(true)
    }
    const getAllPrompts = async (selectedProject) => {
        let selected_id = selectedProject.id
        await services.getAllPrompt(selected_id).then((res) => {
            setPrompt(res)
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            setisProcessing(false)
            setspinnerMessage('')
        })
    }
    const insert = (arr, index, newItem) => [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted item
        newItem,
        // part of the array after the specified index
        ...arr.slice(index)
    ]
    const handleAddNewUserPromptTemplate = (index) => {
        let isLastIndex = prompt.length == index;
        let promptNew = insert(prompt, index, { prompt: "", word_limit: '' })
        setPrompt(promptNew)
        /* if (isLastIndex) {
           this.scrollToBottom();
         }*/
    }
    const handleInputUserPromptTemplate = (index, value) => {
        let createUserPromp = prompt
        //createUserPromp[index].id = index
        createUserPromp[index].prompt = value;
        setPrompt(createUserPromp)
    }
    const handleRemoveUserPromptTemplate = (index) => {
        let createUserPromptTemplates = prompt.filter((x, i) => i != index);
        setPrompt(createUserPromptTemplates)
    }
    const scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    const handleInputWordLimit = (index, value) => {
        let promtNew = prompt;
        //promtNew[index].id = index
        promtNew[index].word_limit = value;
        setPrompt(promtNew)
    }
    const renderCreateUserPromptTemplate = () => {
        return (<div className="user-prompt-template-prompt-area gen-ai-authoring-authoring-prompt-area" style={{padding:"16px"}} onClick={onHandelClickOutSideAttached} >{
            prompt.map((x, i) => {
                return (<CreateUserPromptTemplateNoteBook key={`CreateUserPromptTemplate-${i}-${Math.random()}`} totalCounts={prompt.length}
                    handleInputUserPromptTemplate={handleInputUserPromptTemplate}
                    handleRemoveUserPromptTemplate={handleRemoveUserPromptTemplate}
                    handleAddNewUserPromptTemplate={handleAddNewUserPromptTemplate}
                    promptTemplateText={x.prompt}
                    currentIndex={i}
                    wordLimit={x.word_limit}
                    isFromCreateProject={true}
                    handleInputWordLimit={handleInputWordLimit}
                    errorMsg={errorMsg} />)
            })
        }
            {/*<div style={{ width: "100%" }}
            ref={(el) => { this.messagesEnd = el; }}>
          </div>*/}
        </div>);
    }

    const handleCreateDraft = () => {
        onHandelClickOutSideAttached();
        const isValid = handleValidation('wordLimit', prompt)
        if (isValid) {
            let promt_New = prompt.filter(x => x.prompt).map(val => {
                return {
                    prompt: val.prompt,
                    wordLimit: val.word_limit,
                    readingLevel: selectedReadingLevel
                }
            })
            props.handlePrompt(promt_New)        
                /*let data = {
                    sessionID: sessionID,
                    threadID: threadID,
                    projectName: projectName.trim(),
                    projectType: selectedProjectType,
                    attachedFiles: attachedFiles,
                    prompts: promt_New,
                    newQuestion: promt_New[0].prompt
                }
                history.push({
                    pathname: '/genAIAuthoring2Search',
                    state: data // your data array of objects
                })*/
            }
    }
    const onHandelClickOutSideAttached = (e) => {
        if (attachedFilePopupCollapsed) {
            setattachedFilePopupCollapsed(false)
        }
    }
    return (
        <div className="gen-ai-authoring-ask-question-wrapper" style={{height:'auto'}}>
            <div className="gen-ai-authoring-ask-question-inner-section" >
                    <div className="GenAIAuthoring-project-name-type-section" style={{ alignItems:'start'}}>
                        { <>
                            {(selectProjectType) && <> <div className='GenAIAuthoring-main-prompt-container'
                            style={{ padding: '0px', height:'47vh'}}>
                                <div className="authoring-prompt-label-container" style={{ marginBottom: "12px"}}>
                                    <div className="GenAIAuthoring-div-label">Prompt: </div>
                                    <div className="GenAIAuthoring-div-label">Word Limit</div>
                                </div>
                                {(prompt && prompt.length > 0) && <>
                                    {renderCreateUserPromptTemplate()}
                                </>}
                            </div>
                                <div className="GenAIAuthoring-main-readinglevel-create-draf-container" style={{ marginTop:'12px'}}>
                                    <div className='GenAIAuthoring-main-prompt-reading-level-container' style={{ flexDirection: 'row' }}>
                                        <div className="GenAIAuthoring-div-label GenAIAuthoring-main-prompt-reading-level-label">Reading Level: </div>
                                        {/*<div className="user-prompt-word-limit" style={{ marginLeft : '0px'}}>100</div>*/}
                                        <select
                                            className="user-prompt-word-limit mx-0 wd-140 pd-2"
                                            style={{color:"#EB1700"}}
                                            onChange={(e) => { setSelectedReadingLevel(e.target.value) }}
                                            value={selectedReadingLevel} onClick={onHandelClickOutSideAttached}>
                                            <option value=''>No Reading Level</option>
                                            {readingLevel.map((val) => {
                                                return <option value={val}>{val}th grade</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className='authoring2-create-draft prompt-ans' style={{ display:'flex', justifyContent:'flex-end',width:'100%'}}>
                                        <div className={"GenAIAuthoring-div-label pd-none create-draft"} style={{ fontWeight:'400',fontSize:'16px'}} onClick={handleCreateDraft}>Create Draft</div>
                                        <div className={"GenAIAuthoring-div-label pd-none create-draft"} style={{ fontWeight:'400',fontSize:'16px'}} onClick={()=>{props.handleClose()}}>Close</div>
                                    </div>
                            </>}</>}
                    </div>
                {isProcessing &&
                    <Modal
                        show={isProcessing}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="savePopUp"
                        className="document-processing-newthread"
                        backdropClassName="document-processing-newthread-backdrop"
                        scrollable={true}>
                        <div style={{ padding: "0 5%" }}>
                            <div style={{ fontSize: "14px", textAlign: "center" }}>
                                <Modal.Body>
                                    <img src={imsLoader} alt="" width={100} height={100} />
                                    <div className="saveModal-heading" style={{ color: "#EB1700" }}>{spinnerMessage ? spinnerMessage : `Please wait while uploading the document.`}</div>
                                </Modal.Body>
                            </div>
                        </div>
                    </Modal>}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={closeAlertMessage} />}

            </div>
        </div>
    )
}
export default NoteBookPosterPrompt;